import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles, ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { ListboxComponent } from './ListBox';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { CheckBoxMultipleOutline, CheckboxMultipleBlankOutline } from 'mdi-material-ui';

import './Dropdown.css';


const ColorButton = withStyles(() => ({
  root: {
    color: '#DFCC9B',
    borderColor: '#5b8c76',
    '&:hover': {
      backgroundColor: '#a4bfb3',
      color: '#62300a',
    },
    fontSize: '2.3vh',
  },
}))(Button);

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

const theme = createMuiTheme({
  overrides: {
    MuiChip: {
      root: {
        backgroundColor: '#fef5ea',
        color: '#6e2e00',
        fontSize: '1.5vh',
      },
      deleteIcon: {
        color: '#dfcab9',
        '&:hover': {
          color: '#b2a294',
       },
      },
    },
    MuiIconButton: {
      root: {
        color: '#621e0a',
      },
    },
    MuiPaper: {
      root: {
        color: '#6e2e00',
        backgroundColor: '#fef5ea',
        textTransform: 'capitalize',
      },
    },
    MuiFormLabel: {
      root: {
        color: '#f9e8ce',
        textTransform: 'capitalize',
        '&$focused': {
          color: '#7fb6bb',
       }
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: "#723d26",
      },
      root: {
        '&$focused $notchedOutline': {
           borderColor: '#597f83',
        },
        '&:hover $notchedOutline': {
          borderColor: '#621e0a',
       },
      },
    },
    MuiButton: {
      root: {
        minWidth: '20vh',
        minHeight: '6vh',
      },
    },
    MuiAutocomplete: {
      tag: {
        color: '#6e2e00',
      },
    },
    MuiInputBase: {
      root: {
        color: '#6e2e00',
      },
    },
  },
});

  let availableChoices = {};

export default function SelectAudio(props) {
  const classes = useStyles();
  const [files, setFiles] = useState([]);
  const [selectedfiles, setSelectedFiles] = useState([]);
  const [folders, setFolders] = useState([]);
  const [selectedfolders, setSelectedFolders] = useState([]);
  const [error, setError] = useState(null);
  const [allSelected, setAllSelected] = useState(false);

  useEffect(() => {
    getFolders();
  }, []);

  const baseFileURL = 'http://blackfoot-revitalization.cs.sfu.ca/api/files?folder=';
  const baseFolderURL = 'http://blackfoot-revitalization.cs.sfu.ca/api/folders';
  const allFoldersURL = 'http://blackfoot-revitalization.cs.sfu.ca/api/allfiles';
  const downloadURL = 'http://blackfoot-revitalization.cs.sfu.ca/api/downloadfiles?paths=';


  const getFolders = async () => {
    if (folders.length === 0) {
      let data;
      try {
        const response = await fetch(baseFolderURL);
        data = await response.json();
      } catch (err) {
        setError('Back-end server is offline. No folders available for seleciton.');
        console.error(err);
        return;
      }
      const foldernames = data.map(value => value.foldername);
      setFolders(foldernames);
    }
  };

  const getFiles = async (URL) => {
    let returnfiles;
    try {
      const response = await fetch(URL);
      // Wait for data to be returned
      returnfiles = await response.json();
    } catch (err) {
      setError('Back-end server is offline. No files available for seleciton.');
      console.error(err)
      return;
    }
    if (returnfiles.length) {
      const filelocations = returnfiles.map(value => value.location);
      setFiles(filelocations);
      returnfiles.forEach( result => {
        availableChoices[result.foldername].push(result.location);
      });
    }
  };

  const handleFolders = (event, chosenfolders, reason, details) => {
    if (reason === "remove-option" ) {
      handleDeletion(details.option);
    }
    availableChoices = {};
    setSelectedFolders(chosenfolders);
    chosenfolders.forEach(key => {
      availableChoices[key] = [];
    });
    const quotedchosenfolders = chosenfolders.map( function(folder) {
      return `'${folder}'`
    })
    if (selectedfolders.length === folders.length) {
      setAllSelected(true);
      getFiles(allFoldersURL);
    } else {
      setAllSelected(false);
      if (quotedchosenfolders.length) {
        getFiles(baseFileURL + quotedchosenfolders.join(','));
      }
    }
  };

  const handleFiles = (event, chosenfiles) => {
    setSelectedFiles(chosenfiles);
    if (selectedfiles.length === files.length) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  };

  // Handles request to download audio files
  const handleDownload = async () => {
    const userSelections = {};
    const downloadPaths = [];
    selectedfiles.forEach( file => {
      for (let [key, value] of Object.entries(availableChoices)) {
        if ( value.includes(file) ) {
          if ( !userSelections[key] ) {
            userSelections[key] = [file];
          } else {
            userSelections[key].push(file);
          }
        }
      }
    });
    const path = '/var/www/sounds/';
    Object.keys(userSelections).forEach(folderName => {
      const folderpath = path + `${folderName}/`;
      userSelections[folderName].forEach(file => {
        const fullpath = folderpath + `${file}`;
        downloadPaths.push(fullpath);
      });
    });
    const response = await fetch(downloadURL+downloadPaths.join(','));
    const blob = await response.blob()
    // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob);
    } else {
      // For other browsers: create a link pointing to the ObjectURL containing the blob.
      const objUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objUrl;
      link.download = `Blackfoot-audio-${+new Date()}.zip`;
      link.click();

      // For Firefox it is necessary to delay revoking the ObjectURL.
      setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250);
    }
  }
  const handleDeletion = (deleted) => {
    if ( selectedfiles ) {
      for( let i = 0; i < selectedfiles.length; i++){
        availableChoices[deleted].forEach ( value => {
          if ( selectedfiles[i] === value) {
            selectedfiles.splice(i, 1);
          }
        });
      }
    }
  };

  if (error) {
    return (
      <div className = "error">{error}</div>
    );
  }

  return (
    <ThemeProvider theme={theme}>
    <div className="selectors">
      <Card>
      <CardContent>
        <div className="autocomplete">
          <FormControl>
            <Autocomplete
              multiple
              autoHighlight
              disableCloseOnSelect
              id="category-autocomplete"
              limitTags={2}
              options={folders}
              onChange={handleFolders}
              value={selectedfolders}
              ListboxComponent={ListboxComponent}
              renderInput={(selected, index) => (
                <TextField
                  {...selected}
                  label="category"
                  variant="outlined"/>
              )}/>
          </FormControl>
          {
            !allSelected
            ?
            <Tooltip title="Select All" aria-label="select" placement="right">
              <IconButton
                classes={{
                  root: 'select-all-button',
                }}
                onClick={() => {
                  if (allSelected) {
                    setSelectedFolders([])
                    setAllSelected(false)
                    setFiles([]);
                  } else {
                    setSelectedFolders(folders)
                    setAllSelected(true)
                    getFiles(allFoldersURL);
                  }
                }}
              >
                <CheckBoxMultipleOutline/>
              </IconButton>
            </Tooltip>
            :
            <Tooltip title="Deselect All" aria-label="select" placement="right">
              <IconButton
                onClick={() => {
                  if (allSelected) {
                    setSelectedFolders([])
                    setAllSelected(false)
                    setFiles([])
                  } else {
                    setSelectedFolders(folders)
                    setAllSelected(true)
                    getFiles(allFoldersURL);
                  }
                }}
              >
                <CheckboxMultipleBlankOutline/>
              </IconButton>
            </Tooltip>
          }
        </div>
        {
          selectedfolders.length > 0
          &&
          <div className="autocomplete">
            <FormControl>
              <Autocomplete
                multiple
                autoHighlight
                disableCloseOnSelect
                id="category-autocomplete"
                limitTags={2}
                options={files}
                onChange={handleFiles}
                value={selectedfiles}
                ListboxComponent={ListboxComponent}
                renderInput={(selected, index) => (
                  <TextField
                    {...selected}
                    label="files"
                    variant="outlined"/>
                )}/>
            </FormControl>
            {
              !allSelected
              ?
              <Tooltip title="Select All" aria-label="select" placement="right">
                <IconButton
                  classes={{
                    root: 'select-all-button',
                  }}
                  onClick={() => {
                    if (allSelected) {
                      setSelectedFiles([])
                      setAllSelected(false)
                    } else {
                      setSelectedFiles(files)
                      setAllSelected(true)
                    }
                  }}
                >
                  <CheckBoxMultipleOutline/>
                </IconButton>
              </Tooltip>
              :
              <Tooltip title="Deselect All" aria-label="select" placement="right">
                <IconButton
                  className="iconButton"
                  onClick={() => {
                    if (allSelected) {
                      setSelectedFiles([])
                      setAllSelected(false)
                    } else {
                      setSelectedFiles(files)
                      setAllSelected(true)
                    }
                  }}
                >
                  <CheckboxMultipleBlankOutline/>
                </IconButton>
              </Tooltip>
            }
          </div>
        }
        <div className="autocomplete">
          <ColorButton variant="outlined" onClick={handleDownload} className={classes.margin} disabled={!selectedfolders.length || !selectedfiles.length }>
            Download
          </ColorButton>
        </div>
      </CardContent>
      </Card>
    </div>
    </ThemeProvider>
  );
};
